module.exports = __webpack_public_path__ + "static/media/1010263.537df75b.jpg";